export const registerIcons = () => require("./generated/index");
